.container {
  position: fixed;
  z-index: 111111;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.6rem 1.6rem 3.2rem;
  background: var(--color-grayscale-woodsmoke);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: $bp-small) {
    display: none;
  }
}

.actions {
  display: flex;
  gap: 1.6rem;
}

.custom-trash-can {
  path {
    stroke: var(--color-error);
  }
}
